// import ololog from 'ololog';
// ololog.handleNodeErrors();
// export const log = ololog.configure( {} );
// log.debug = log;

export const log = console;
export default log;
